import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Bang } from '../../assets/icons/bang.svg';

import styles from './styles.module.scss';
import { Input } from 'components';
import actionTypes from 'store/profile/actionTypes';

const ReferralPayments = () => {
  const dispatch = useDispatch();
  const { referralSettings, referralPayments } = useSelector((state) => state.profile);
  const isLoadingSettings = useSelector((state) => state.api.GET_REF_SETTINGS);
  // eslint-disable-next-line no-unused-vars
  const [referralCode, setReferralCode] = React.useState(referralSettings?.referral_code);
  const [referralLink, setReferralLink] = React.useState(referralSettings?.referral_link);

  React.useEffect(() => {
    setReferralCode(referralSettings?.referral_code);
    setReferralLink(referralSettings?.referral_link);
  }, [isLoadingSettings.success]);

  const withdraw = () => dispatch({ type: actionTypes.POST_WITHDRAW });
  // eslint-disable-next-line max-len
  const updateRefCode = () => {
    dispatch({ type: actionTypes.UPDATE_REF_CODE, payload: { referralCode } });
    setTimeout(() => {
      dispatch({ type: actionTypes.GET_REF_SETTINGS });
    }, 1000);
  };

  const handleCount = (minInvites, currentRefUsers) => ((typeof minInvites !== 'undefined' && typeof currentRefUsers !== 'undefined') ? minInvites - currentRefUsers : '');

  const handlePayoutButton = () => {
    if (referralPayments.is_withdrawal_available) {
      return (
        <button
          className={`${styles.payoutButton} ${styles.center}`}
          type="button"
          onClick={() => withdraw()}
        >
          PAYOUT
        </button>
      );
    }

    // eslint-disable-next-line max-len
    if (!referralPayments.is_withdrawal_available && handleCount(referralSettings.min_invites, referralSettings.referred_users) <= 0) {
      return (
        <button
          className={`${styles.payoutButton} ${styles.inactive}`}
          type="button"
        >
          <Bang className={styles.bang} />
          <span className={styles.mAuto}>Conditions for payout are met</span>
        </button>
      );
    }
    return (
      <button
        className={`${styles.payoutButton} ${styles.inactive}`}
        type="button"
      >
        <Bang className={styles.bang} />
        <span>
          Bring
          {' '}
          <span className={styles.boldText}>
            {handleCount(referralSettings.min_invites, referralSettings.referred_users)}
          </span>
          {' '}
          more referrals to unlock payouts
        </span>
      </button>
    );
  };

  return (
    <div className={`${styles.box} ${styles.boxFlex}`}>
      <div className={styles.paymentsCol}>
        <span className={styles.boxHeader}>Referral Payments</span>
        <span className={styles.refAmount}>
          €
          {referralPayments.available_balance}
          {referralPayments.pending_balance ? ` (€${referralPayments.pending_balance} pending)` : ''}
        </span>
        {handlePayoutButton()}
      </div>
      <div className={styles.paymentsCol}>
        <div className={styles.inputWrapper}>
          <span className={styles.inputLabel}>
            Referral link
          </span>
          <Input
            value={referralLink}
            name="reflink"
            type="copy"
            onButtonClick={() => { navigator.clipboard.writeText(referralLink); }}
          />
        </div>
        <div className={styles.inputWrapper}>
          <span className={styles.inputLabel}>
            Referral code
          </span>
          <Input
            value={referralCode}
            onChange={(e) => setReferralCode(e.target.value)}
            name="refcode"
            type="copy"
            onButtonClick={() => { navigator.clipboard.writeText(referralCode); }}
          />
          <button
            className={`${styles.payoutButton} ${styles.center}`}
            type="button"
            onClick={() => updateRefCode()}
          >
            Update Referral Code
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralPayments;
